import React, { FC } from 'react';

const IconLogoDarkTheme: FC = () => {
  return (
    <svg viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="47" height="47" rx="10" fill="#201F24" />
      <rect width="47" height="47" rx="10" fill="#211F24" />
      <path
        d="M21.664 13.1568L14.2367 35.7959C11.7733 33.9416 9.94886 31.4224 9 28.5647L14.051 13.1568H21.664Z"
        fill="#D7F525"
      />
      <path
        d="M27.4876 25.0105L22.8882 39C20.4361 38.8455 18.0569 38.1382 15.9452 36.936L19.8571 25.0105H27.4876Z"
        fill="#D7F525"
      />
      <path
        d="M32.0446 11.0736L28.065 23.2079H20.462L25.1166 9C27.565 9.15682 29.9395 9.86751 32.0446 11.0736Z"
        fill="#D7F525"
      />
      <path
        d="M39 19.4399L33.949 34.8478H26.341L33.7608 12.2087C36.2244 14.0633 38.0495 16.5823 39 19.4399Z"
        fill="#D7F525"
      />
    </svg>
  );
};

export default IconLogoDarkTheme;
